import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const DocumentIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}

            <g id="Icon/documento">
                <g id="documento-firmado 1" clipPath="url(#clip0_138_4746)">
                    <path
                        id="Vector"
                        d="M10.9546 8.11361V8.61361H11.4546H14.2955V15.7272H6.70459V6.20452C6.70459 5.95739 6.80276 5.72038 6.97751 5.54563C7.15226 5.37088 7.38927 5.27271 7.63641 5.27271H10.9546V8.11361ZM8.11368 9.04543H7.61368V9.54543V10.5V10.9545V11V11.4545V12.4091V12.9091H8.11368H9.30958C8.78823 13.0049 8.30179 13.2489 7.91096 13.6165L7.53701 13.9682L7.89847 14.3328L8.57047 15.0105L8.90336 15.3462L9.25717 15.0326C9.3924 14.9128 9.56173 14.8391 9.74063 14.8215C9.75422 14.8307 9.77074 14.8423 9.79224 14.8575C10.1469 15.1405 10.5872 15.295 11.0413 15.2954H11.0417C11.6932 15.2954 12.2289 14.9394 12.5755 14.6336C12.9322 14.3189 13.1643 13.9905 13.2155 13.9158L13.4989 13.5031L13.0859 13.2203L12.6315 12.9091H12.8864H13.3864V12.4091V11.4545V11V10.9545V10.5V9.54543V9.04543H12.8864H8.11368ZM10.9643 13.2941C10.7334 13.1045 10.4625 12.9734 10.1744 12.9091H11.5287C11.4603 12.9929 11.3673 13.0941 11.2667 13.1819C11.1945 13.2448 11.13 13.2907 11.0785 13.3185C11.0568 13.3303 11.0421 13.3363 11.0338 13.3392C11.0175 13.336 11.0022 13.3282 10.9899 13.3166L10.9775 13.3049L10.9643 13.2941ZM12.9091 5.78222L13.786 6.65907H12.9091V5.78222Z"
                        fill="currentColor"
                        stroke="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_138_4746">
                    <rect
                        width="11.4545"
                        height="11.4545"
                        fill="white"
                        transform="translate(4.77295 4.77271)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DocumentIcon;
